import { makeStyles } from "@cirrus/ui-kit";
import {DefaultColors} from "@cirrus/legacy/app-components/app/styles/colors/colors-default";

export const useStyles = makeStyles({
  errorButton: {
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "20px",
    display: "block",
    color: DefaultColors.white,
    backgroundColor: `${DefaultColors.green_510} !important`,
    borderColor: "transparent !important",
    border: "0px !important",
    borderRadius: "4px",
    fontSize: "14px",
    lineHeight: "16px",
    textAlign: "center",

    "&:hover": {
      color: `${DefaultColors.white} !important`,
      backgroundColor: `${DefaultColors.green_500} !important`,
      padding: "0 8px",
      height: "32px",
    }
  },
  viewerError: {
    display: "flex",
    verticalAlign: "middle",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  }
})
